import { logicProcessor, LogicProcessor } from './processors';
import { 
  processMultiAxisScoringLogic, 
  processMultiAxisScoring,
  setupMultiAxisScoringListener,
  formatWeightsForStore
} from './core/multiAxisScoringLogic';
import { processSkipLogic } from './core/skipLogic';
import type { LogicName } from './types';

// Register standard processors
logicProcessor.registerProcessor('skipLogic' as LogicName, processSkipLogic);
logicProcessor.registerProcessor('multiAxisScoring' as LogicName, processMultiAxisScoringLogic);

// Export utility functions
export { isSuccessful, getNextAction, getRedirectUrl } from './processors/utils';

// Export processors for direct use
export { 
  processSkipLogic, 
  processMultiAxisScoringLogic, 
  processMultiAxisScoring,
  setupMultiAxisScoringListener,
  formatWeightsForStore
};

// Export the LogicProcessor class and instance for extension
export { LogicProcessor, logicProcessor };

// Export types
export type * from './types'; 